import { useSession } from '../lib/session'

/** Handpicked's tree, cut from their logo file (web/public/handpicked-tree*.png, transparent). */
export function HandpickedTree({ size = 40 }: { size?: number }) {
  return <img className="hp-tree" src={size > 80 ? '/handpicked-tree.png' : '/handpicked-tree-160.png'} width={size} height={size} alt="" aria-hidden="true" />
}

/** The install's mark for a sidebar: Handpicked's tree and spaced wordmark, or the org's initial and name. */
export function BrandMark({ fallbackName, sub }: { fallbackName: string; sub?: string }) {
  const { config } = useSession()
  if (config?.brand === 'handpicked') {
    return (
      <div className="sidebar-brand hp-brand">
        <HandpickedTree />
        <span className="hp-brand-text">
          <span className="hp-wordmark">Handpicked</span>
          {sub && <span className="hp-brand-sub">{sub}</span>}
        </span>
      </div>
    )
  }
  return (
    <div className="sidebar-brand">
      <span className="avatar avatar-sm" aria-hidden="true">{fallbackName.slice(0, 1)}</span>
      <span>{fallbackName}</span>
    </div>
  )
}
